import { Container } from "lucide-react";
import { Link } from "react-router-dom";
import { PageContainer } from "@/components/page-container";
import { Alert, AlertAction } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";

export function FirstManagedSiteBanner() {
  return (
    <PageContainer spacing="compact">
      <Alert className="grid-cols-[auto_minmax(0,1fr)] border-dashed border-border bg-muted/40 text-foreground md:grid-cols-[auto_minmax(0,1fr)_auto] [&>svg]:text-foreground md:items-center">
        <Container className="mt-0.5 size-5 self-start md:mt-0 md:self-center" />
        <div className="min-w-0 space-y-1">
          <p className="font-medium tracking-tight">
            Set up your first managed site
          </p>
          <p className="text-sm leading-relaxed text-foreground/80">
            Create your first site to unlock forms, workers, reports, and
            approvals.
          </p>
        </div>
        <AlertAction className="md:col-start-3 md:row-span-2 md:row-start-1 md:mt-0 md:justify-self-end">
          <Button asChild size="sm" className="w-full sm:w-auto">
            <Link to="/sites/new">Add a site</Link>
          </Button>
          <Button
            asChild
            size="sm"
            variant="outline"
            className="w-full sm:w-auto"
          >
            <Link to="/sites">View sites</Link>
          </Button>
        </AlertAction>
      </Alert>
    </PageContainer>
  );
}
